import { useEffect, useState } from "react";
import Container from "../../Components/Container";
import { PlanCard } from "../../Components/Price/PlanCard";
import { Title, TitleCard } from "../../Components/Price/Price.styles";
import Row from "../../Components/Row";

export default function Price() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    async function fetchPlans() {
      try {
        const res = await fetch("https://api-w.meuroom.com.br/signature/plan"); // ajuste para sua rota real
        const data = await res.json();

        // Transformando no formato do PlanCard
        const formatted = data.map((plan: any) => {
          // Pega o ciclo mensal como referência
          const mensal = plan.cicles[0];

          return {
            title: plan.name,
            features: [
              `${mensal?.messages.toLocaleString()} mensagens/mês`,
              plan.description,
            ],
            price: mensal ? mensal.amount.toLocaleString("pt-BR") : "0",
            // Badge opcional: por exemplo, se for o mais caro ou algum outro critério
            badge: plan.name === "Business" ? "Mais popular" : undefined,
            badgeColor: plan.name === "Business" ? "#E49E1B" : undefined,
            badgeTextColor: plan.name === "Business" ? "#000" : undefined,
          };
        });

        setPlans(formatted);
      } catch (err) {
        console.error("Erro ao buscar planos:", err);
      }
    }

    fetchPlans();
  }, []);

  return (
    <Container
      id="section-3"
      style={{ textAlign: "center", backgroundColor: "#000", marginTop: 40 }}
      full
    >
      <Title>
        Planos & <span style={{ color: "#E4DA1B" }}>Preços</span>
      </Title>
      <TitleCard $mb={30} style={{color: "#fff"}}>
        Escolha o plano ideal para o tamanho do seu atendimento.
      </TitleCard>

      <Row
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        {plans.map((plan: any, i) => (
          <PlanCard key={i} {...plan} />
        ))}
      </Row>
    </Container>
  );
}
